import { createClient } from '@supabase/supabase-js'

function cleanEnv(value) {
  if (!value) return value
  return value.trim().replace(/^["']|["']$/g, '')
}

const supabaseUrl = cleanEnv(process.env.VITE_SUPABASE_URL)
const supabaseAnonKey = cleanEnv(process.env.VITE_SUPABASE_ANON_KEY)

if (!supabaseUrl || !supabaseAnonKey) {
  // eslint-disable-next-line no-console
  console.error('[Supabase] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Check .env and dev server setup.')
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '')
